module.exports = __webpack_public_path__ + "img/marker-oil-refinery-yellow.45627808.png";